import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SessionService } from '@domain/application/observable-services/session.service';
import {
  appendOutsideTaxForm,
  createOutsideTaxForm,
  forceAffirmativeValidation,
} from '@modules/business-accounts/forms/outside-tax/outside-tax.form';
import { IBaseFormBuilder } from '../../../builders/base-builder.class';
import { BIRTHDAY_VALIDATORS } from '../../../common-fields/birthday.field';
import { EMAIL_VALIDATOR } from '../../../common-fields/email.field';

export class NaturalPersonDataNonClientFormBuilder implements IBaseFormBuilder {
  private form: FormGroup;

  constructor(private readonly sessionService: SessionService, private initialValues?: any) {
    this.form = new FormGroup({});
  }

  public build() {
    const { personType } = this.sessionService.getCommonInfoValue;
    if (personType == undefined) this.addTaxResidenceForm();
    this.addPersonalFields();
    this.addSectorFields();
    this.addMiscFields();
  }

  public getResult(): FormGroup {
    return this.form;
  }

  private initialValue(fieldName: string) {
    return this.initialValues[fieldName] || null;
  }

  private addTaxResidenceForm(): this {
    appendOutsideTaxForm({
      to: this.form,
      with: createOutsideTaxForm({
        isTaxOutsideValidators: [forceAffirmativeValidation],
      }),
      // with: createOutsideTaxForm(),
    });
    return this;
  }

  private addPersonalFields() {
    this.form.addControl(
      'personalData',
      new FormGroup({
        ruc: new FormControl(this.initialValue('ruc'), [
          Validators.required,
          Validators.pattern(/^10/),
          Validators.minLength(11),
        ]),
        firstName: new FormControl(null, [Validators.required]),
        middleName: new FormControl(null),
        lastName: new FormControl(null, [Validators.required]),
        motherLastName: new FormControl(null, [Validators.required]),
        birthDate: new FormControl(null, BIRTHDAY_VALIDATORS),
        businessName: new FormControl('', Validators.required),
        gender: new FormControl(null, [Validators.required]),
        email: new FormControl(null, EMAIL_VALIDATOR),
        isPEP: new FormControl(false, [Validators.required]),
        maritalStatus: new FormControl(null, [Validators.required]),
        phoneNumber: new FormControl(null, [Validators.required, Validators.pattern(/^9/), Validators.minLength(9)]),
        phoneCarrier: new FormControl(null, [Validators.required]),
        department: new FormControl(null, [Validators.required]),
        province: new FormControl(null, [Validators.required]),
        district: new FormControl(null, [Validators.required]),
        streetType: new FormControl(null, [Validators.required]),
        streetName: new FormControl(null, [Validators.required]),
        streetNumber: new FormControl(null, [Validators.required]),
        block: new FormControl(null),
        lot: new FormControl(null),
        apartment: new FormControl(null),
        neighborhood: new FormControl(null),
        landmark: new FormControl(null),
        birthCountry: new FormControl(null),
        residenceCountry: new FormControl(null),
        nationality: new FormControl(null),
        //Added only to requirements: Send the names instead of code.
        departmentName: new FormControl(null),
        provinceName: new FormControl(null),
        districtName: new FormControl(null),
      })
    );
  }

  private addMiscFields() {
    this.form.addControl(
      'miscData',
      new FormGroup({
        departmentId: new FormControl(null),
        provinceId: new FormControl(null),
        districtId: new FormControl(null),
      })
    );
  }
  private addSectorFields() {
    this.form.addControl(
      'sectorData',
      new FormGroup({
        sectorCode: new FormControl(null, [Validators.required]),
        subSectorCode: new FormControl(null, []),
      })
    );
  }
}

export const getPersonalDataNonClientFormInstance = ({ from: form }: { from: FormGroup }) =>
  form.get('personalData') as FormGroup;

export const getSectorDataNonClientFormInstance = ({ from: form }: { from: FormGroup }) =>
  form.get('sectorData') as FormGroup;

export const getMiscDataNonClientFormInstance = ({ from: form }: { from: FormGroup }) =>
  form.get('miscData') as FormGroup;
